"use client";

import { useEffect } from "react";

/**
 * Suppress console output in production to improve Lighthouse scores
 * Also suppresses known non-critical errors like image 403s from external CDNs
 * This component runs on the client side and suppresses non-critical console output
 */
export function ConsoleSuppressor() {
  useEffect(() => {
    // Filter out known non-critical errors (both dev and prod)
    const originalError = console.error;
    console.error = (...args: unknown[]) => {
      const errorMessage = args.join(" ");

      // Suppress known non-critical image loading errors
      const suppressPatterns = [
        "fbcdn.net", // Facebook CDN images
        "cdninstagram.com", // Instagram CDN images
        "tiktokcdn", // TikTok CDN images
        "403 (Forbidden)", // General 403 errors from CDNs
      ];

      const shouldSuppress = suppressPatterns.some((pattern) =>
        errorMessage.includes(pattern),
      );

      if (!shouldSuppress) {
        originalError(...args);
      }
    };

    // In production, also suppress other console output
    if (process.env.NODE_ENV === "production") {
      const noop = () => {};

      // Suppress warnings, info, and debug logs
      console.warn = noop;
      console.info = noop;
      console.debug = noop;
    }
  }, []);

  return null;
}
